<template>
  <v-row justify="center">
    <v-dialog
      max-width="700px"
      :value="isVisible"
      persistent
      @keydown.esc="closeModal"
    >
      <v-card style="background-color: #D9D9D9;">
        <v-card-title>
          <span class="headline sub-title">
            {{ label }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <div class="mb-6" v-for="workshop of workshops" :key="workshop.id">
              <p class="mb-0">
                <b>{{ workshop.name }}</b>
              </p>
              <p>
                Aktywne do:
                {{ getExpirationDateWithTime(workshop.expirationTime) }}
              </p>
              <div
                @click="handleWorkshopClick(workshop)"
                style="cursor: pointer; color: #8B857D; display: flex; gap: 5px; align-items: center;"
              >
                {{
                  checkExpirationTimeIsAfterNow(workshop.expirationTime)
                    ? "Przejdź"
                    : "Przedłuż dostęp"
                }}
                <svg
                  width="31"
                  height="16"
                  viewBox="0 0 31 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M30.7071 8.70711C31.0976 8.31658 31.0976 7.68342 30.7071 7.29289L24.3431 0.928932C23.9526 0.538408 23.3195 0.538408 22.9289 0.928932C22.5384 1.31946 22.5384 1.95262 22.9289 2.34315L28.5858 8L22.9289 13.6569C22.5384 14.0474 22.5384 14.6805 22.9289 15.0711C23.3195 15.4616 23.9526 15.4616 24.3431 15.0711L30.7071 8.70711ZM0 8V9H30V8V7H0V8Z"
                    fill="#8B857D"
                  />
                </svg>
              </div>
            </div>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="#8B857D" text v-on:click="closeModal">
            <font-awesome-icon icon="times" class="mr-1" />
            Zamknij
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import moment from "moment";

export default {
  name: "WorkshopsListModal",
  props: ["isVisible", "label", "workshops", "handleWorkshopClick"],

  data: () => ({}),
  methods: {
    closeModal() {
      this.email = "";
      this.$emit("closeModal");
    },
    getExpirationDateWithTime(date) {
      if (date) {
        return moment(date)
          .locale("pl")
          .format("DD MMMM YYYY HH:mm");
      }
      return "";
    },
    checkExpirationTimeIsAfterNow(expirationTime) {
      return moment(expirationTime).isAfter(moment());
    },
  },
};
</script>
<style type="scss" scoped>
.headline {
  margin-bottom: 2rem;
  word-break: break-word;

}
a {
  color: #54514c;
}

@media screen and (max-width: 500px) {
  .headline {
    font-size: 18px !important;
    word-break: break-word;
  }
}
</style>
